import React from 'react';
import { RailsPredictiveSearchResult } from '@sls-react/typings/services/rails/predictiveSearch';
import ShopLink from '@sls-react/components/Links/ShopLink';

interface Props {
  className?: string;
  result: RailsPredictiveSearchResult;
}

const PredictiveResultLink: React.FC<Props> = ({
  children,
  className,
  result,
}) => (
  <ShopLink
    className={className}
    path={result.path}
    type={result.type === 'navigation' ? 'nav' : undefined}
    query={{ src: 'predictive-search' }}
  >
    {children}
  </ShopLink>
);

export default PredictiveResultLink;
